import {
  Heart,
  Users,
  Target,
  User,
  Compass,
  Award,
  Wallet,
  PiggyBank,
  Apple,
  Dumbbell,
  Brain,
  Shield,
} from "lucide-react";

// Category definitions for LIFE Score Assessment
export const categories = [
  // Love (3)
  {
    key: "family",
    name: "Family",
    icon: Users,
    color: "#ef4444",
    category: "Love",
    description: "Your relationships with family members",
  },
  {
    key: "friends",
    name: "Friends",
    icon: User,
    color: "#ef4444",
    category: "Love",
    description: "Your social connections and friendships",
  },
  {
    key: "romance",
    name: "Romance",
    icon: Heart,
    color: "#ef4444",
    category: "Love",
    description: "Your romantic relationships and intimacy",
  },

  // Inspiration (3)
  {
    key: "flow",
    name: "Flow",
    icon: Target,
    color: "#3b82f6",
    category: "Inspiration",
    description: "Being in your zone and feeling engaged",
  },
  {
    key: "direction",
    name: "Direction",
    icon: Compass,
    color: "#3b82f6",
    category: "Inspiration",
    description: "Having clarity on your life path",
  },
  {
    key: "successes",
    name: "Successes",
    icon: Award,
    color: "#3b82f6",
    category: "Inspiration",
    description: "Achieving meaningful accomplishments",
  },

  // Finance (2)
  {
    key: "income",
    name: "Income",
    icon: Wallet,
    color: "#22c55e",
    category: "Finance",
    description: "Your earning potential and income satisfaction",
  },
  {
    key: "finances",
    name: "Financial Security",
    icon: PiggyBank,
    color: "#22c55e",
    category: "Finance",
    description: "Your savings, investments, and financial stability",
  },

  // Equilibrium (4)
  {
    key: "nutrition",
    name: "Nutrition",
    icon: Apple,
    color: "#a855f7",
    category: "Equilibrium",
    description: "Your eating habits and nutritional health",
  },
  {
    key: "activity",
    name: "Physical Activity",
    icon: Dumbbell,
    color: "#a855f7",
    category: "Equilibrium",
    description: "Your exercise routine and physical fitness",
  },
  {
    key: "mental_health",
    name: "Mental Health",
    icon: Brain,
    color: "#a855f7",
    category: "Equilibrium",
    description: "Your emotional wellbeing and mental state",
  },
  {
    key: "safety",
    name: "Safety & Security",
    icon: Shield,
    color: "#a855f7",
    category: "Equilibrium",
    description: "Your physical safety and life security",
  },
];

export const sections = ["Love", "Inspiration", "Finance", "Equilibrium"];
